import {
  ProReportResponse,
  ProReportVesselDestinationResponse,
  ProVesselTypes,
} from '../models/pro.model';
import { wrapRequest } from './base';

const getProReport = async (
  unLocode: string,
  vesselType?: string
): Promise<ProReportResponse> => {
  const portUnLocode = unLocode.replace(' ', '').toUpperCase();
  const typeCheckedVessel =
    vesselType === ProVesselTypes.UNKNOWN ? '' : vesselType;
  const query = typeCheckedVessel
    ? `?vessel-type=${encodeURIComponent(typeCheckedVessel)}`
    : '';
  return wrapRequest(
    'get',
    'north_standard',
    `/ports/reports/${portUnLocode}${query}`
  );
};

export const getVesselDestination = async (
  imos: string[]
): Promise<ProReportVesselDestinationResponse[]> => {
  const query = imos.length
    ? `?imos=[${imos
        .filter(Boolean)
        .map((imo) => imo.replace(' ', ''))
        .join(',')}]`
    : '';

  // eslint-disable-next-line no-console
  console.log(
    `Fetching vessel destination for IMOs: ${imos.join(
      ', '
    )} with query: ${query}`
  );

  return wrapRequest('get', 'north_standard', `/vessel-information${query}`);
};

export default getProReport;
